export const baseUrl = "https://aladamra.supagrow.in";

export const getHome = "api/gethomepage";
export const getAbout = "api/getaboutpage";

export const getBlog = "api/getblogs";
export const getBlogDetail = "api/blogdetails";

export const getService = "api/getservices";
export const getServiceDetail = "api/servicedetails";

export const storContact = "api/storecontactapi";
export const emailSubscribe = "api/storenewsapi";
export const footerSecEndPoint = "api/footerpage";
